/**
 * Account information PNZ-API-CentreLib
 *
 * This file was automatically generated by APIMATIC v3.0 ( https://www.apimatic.io ).
 */

import { array, lazy, object, Schema } from '../schema';
import { Beneficiary, beneficiarySchema } from './beneficiary';

export interface Data4 {
  beneficiary: Beneficiary[];
}

export const data4Schema: Schema<Data4> = object({
  beneficiary: ['Beneficiary', array(lazy(() => beneficiarySchema))],
});
